// gitlab-evidence-schemas.ts
//
// Zod schemas cho GitLab REST v4 response (input NGOÀI, phải parse — không
// tin cấu trúc). Split khỏi gitlab-merge-request-evidence-client.ts để giữ
// file kia ≤200 dòng. `.passthrough()` vì response GitLab thật có hàng chục
// field khác không cần thiết cho v1 — chỉ validate field caller thực sự dùng.
import { z } from "zod";

export const MergeRequestSchema = z
  .object({
    iid: z.number(),
    project_id: z.number(),
    state: z.string(),
    source_branch: z.string(),
    target_branch: z.string(),
    sha: z.string().nullable(),
    web_url: z.string(),
    draft: z.boolean().optional(),
    merge_status: z.string().optional(),
  })
  .passthrough();

export const PipelineSchema = z
  .object({
    id: z.number(),
    sha: z.string(),
    ref: z.string(),
    status: z.string(),
    web_url: z.string(),
  })
  .passthrough();

export const JobSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    stage: z.string(),
    status: z.string(),
    allow_failure: z.boolean().optional(),
    web_url: z.string(),
  })
  .passthrough();

export type GitlabMergeRequest = z.infer<typeof MergeRequestSchema>;
export type GitlabPipeline = z.infer<typeof PipelineSchema>;
export type GitlabJob = z.infer<typeof JobSchema>;
